import { getLocalStorage, setLocalStorage } from './cookie';

// params{key: string, data: any, isNecessary: boolean}
export class Queue {
  constructor(items) {
    this.items = items || [];
  }
  set(params) {
    if (!params.key || typeof (params.key) !== 'string') return { ret: -30001, msg: 'params Error' };
    if (this.items.length >= 5) {
      const sameKeyIndex = this.items.findIndex(item => item.key === params.key);
      const index = sameKeyIndex === -1 ? this.items.findIndex(item => !item.isNecessary) : sameKeyIndex;
      if (index === -1) {
        this.items.push(params);
      } else {
        this.items.splice(index, 1);
        this.items.push(params);
      }
    } else {
      const index = this.items.findIndex(item => item.key === params.key);
      if (index === -1) {
        this.items.push(params);
      } else {
        this.items.splice(index, 1);
        this.items.push(params);
      }
    }
    this.setGlobal();
  }
  get(key) {
    if (!key || typeof (key) !== 'string') return { ret: -30001, msg: 'params Error' };
    const item = this.items.find(item => item.key === key);
    const itemIndex = this.items.findIndex(item => item.key === key);
    if (itemIndex !== -1) {
      this.items.splice(itemIndex, 1);
    }
    this.setGlobal();
    return { ret: 0, msg: 'success', data: item };
  }
  clear(key) {
    if (!key || typeof (key) !== 'string') return { ret: -30001, msg: 'params Error' };
    const itemIndex = this.items.findIndex(item => item.key === key);
    if (itemIndex !== -1) {
      this.items.splice(itemIndex, 1);
    }
    this.setGlobal();
  }
  clearAll() {
    this.items = [];
    this.setGlobal();
  }
  setGlobal() {
    setLocalStorage('cachePage', this.items);
  }
}
const items = getLocalStorage('cachePage') || [];
const cacheQueue = new Queue(items);
export default cacheQueue;
